import React from 'react';

import { RecursiveMenu, CoreLink } from '@uncinc/react-drupal-core';
import { Container, Image } from '@uncinc/uncinc-react-kitchen-sink';
import Logo from '../../../assets/images/logo.svg';

import './style.scss';

const FooterMenu = () => (
  <div className="FooterMenu">
    <Container>

      <CoreLink
        href="/"
        className="FooterMenu__logo"
      >
        <Image src={Logo} alt="Logo" />
      </CoreLink>

      <div className="FooterMenu__menu">
        <RecursiveMenu
          navProps={{ 'aria-label': 'Footer menu' }}
          menuId="footer"
          maxLevel={2}
        />
      </div>

      <div className="FooterMenu__secondary-menu">
        <RecursiveMenu
          navProps={{ 'aria-label': 'Secondary footer menu' }}
          menuId="secondary-footer"
          maxLevel={1}
          additionalClassName="magic-line thin"
        />
      </div>

    </Container>
  </div>
);


export default FooterMenu;
